<template>
  <v-container class="px-0 py-0 page-login" fluid>
    <v-layout row wrap align-center>
      <v-flex xs12 sm12 md12 tag="section" class="login-area" align-center>
        <img src="@/assets/images/mais_solucoes_horizontal.svg" class="logo" alt="logo Mais Soluções">
        <slot></slot>
      </v-flex>
      <v-footer class="pa-3" color="transparent">
        <img src="@/assets/images/mais_solucoes_horizontal.svg" class="logo-footer" alt="logo Mais Soluções">
        <div class="caption ml-3 mediumGray--text">
        Copyright &copy; {{ new Date().getFullYear() }} modera.app - Todos os direitos reservados</div>
      </v-footer>
    </v-layout>
  </v-container>
</template>

<script>
export default {
}
</script>

<style lang="sass">
  @import '../assets/style/login'
</style>
